export const currencyFormatter = (price): string => {
  return new Intl.NumberFormat('es-AR', {
    maximumFractionDigits: 2,
    minimumFractionDigits:2,
  }).format(price);
};
